

import React, { useEffect, useState, useContext } from "react";
import { Grid, TextField, Button, Autocomplete } from "@mui/material";
import { getSearchFilterOptions } from "../services/Api";
import { GlobalContext } from "../GlobalContext";
import { FiFilter } from "react-icons/fi";
import SearchFilterModal from "./SearchFilterModal";
import { useTranslation } from 'react-i18next';

export default function SearchFilter({
  paddingClasses = "pt-[660px] lg:pt-[220px]",
  sortBy = "latest",
  getPropertyData,
  selectedCategory,
  setSelectedCategory,
  projectOptions,
  communityOptions,
  roomOptions,
  unitTypeOptions,
  salesStatusOptions,
  projectStatusOptions,
  projectTypeOptions,
  amenityOptions,
  setProjectStatus,
  projectStatus,
  setSalesStatus,
  salesStatus,
  setProjectType,
  projectType,
  setUnitType,
  unitType,
  setRooms,
  rooms,
  setFacility,
  facility,
  setCommunity,
  community,
  setRentalGuarantee,
  rentalGuarantee,
  setPaymentPlan,
  paymentPlan,
  setDeliveryPlan,
  deliveryPlan,
  setMinPrice,
  minPrice,
  setMaxPrice,
  maxPrice,
  setMinArea,
  minArea,
  setMaxArea,
  maxArea,
  setDownPayment,
  downPayment,
  setDeliveryDate,
  deliveryDate,
  handleRest,

  setNewUnitType,
  newUnitType,
}) {
  const {
    setGlobalVar,
    setGetProperty,
    setPage,
    type,
    setType,
    budget,
    setBudget,
    handover,
    setHandover,
    locationSelect,
    setLocationSelect,
    developer,
    setDeveloper,
    developerOther,
    setDeveloperOther,
    project,
    setProject,
    page,
    setActiveFilters,
    setActiveFilter,
    keywords,
    setKeywords,
  } = useContext(GlobalContext);

  const [typeOptions, setTypeOptions] = useState([]);
  const [budgetOptions, setBudgetOptions] = useState([]);
  const [handoverYears, setHandoverYears] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [developerOptions, setDeveloperOptions] = useState([]);

  const [typeOther, setTypeOther] = useState("");
  
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

   const { t, i18n } = useTranslation();
const isArabic = i18n.language === 'ar';


  const emirateOptions = [
    { label: 'All Emirates', value: 'All Emirates' },
    { label: 'Abu Dhabi', value: 'Abu Dhabi' },
    { label: 'Dubai', value: 'Dubai' },
    { label: 'Sharjah', value: 'Sharjah' },
    { label: 'Ajman', value: 'Ajman' },
    { label: 'Umm Al Quwain', value: 'Umm Al Quwain' },
    { label: 'Ras Al Khaimah', value: 'Ras Al Khaimah' },
    { label: 'Fujairah', value: 'Fujairah' }
  ];

  useEffect(() => {
    async function loadFilterOptions() {
      const data = await getSearchFilterOptions();
      setTypeOptions(["Any Type", ...data.types]);
      setBudgetOptions(data.budget_options);
      // const currentYear = new Date().getFullYear();

      // const rawYears = data.handover_years || [];

      // // Clean and sort years
      // const futureYears = rawYears
      //   .filter(year => !isNaN(year) && Number(year) >= currentYear)
      //   .sort((a, b) => Number(a) - Number(b));

      // // Final list: Ready to move, current year, then future
      // const sortedYears = ["Ready to move", ...futureYears];
      // if (response.handover_years) {
                const currentYear = new Date().getFullYear();

                // Filter out invalid years and future years (excluding the current year)
                const futureYears = data.handover_years
                    .filter(year => !isNaN(year) && Number(year) > currentYear)
                    .sort((a, b) => Number(a) - Number(b));

                // Set state with "Ready to move" at the start, followed by future years
                setHandoverYears(["Ready to move", ...futureYears]);
            

      // setHandoverYears(sortedYears);
      setLocationOptions(["All Cities", ...data.locations]);
      setDeveloperOptions(["Any Developer", ...data.developers]);
    }
    loadFilterOptions();
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      e.preventDefault();
      if (!keywords.includes(inputValue.trim())) {
        setKeywords([...keywords, inputValue.trim()]);
      }
      setInputValue("");
    }
  };

  const formatNumber = (value) => {
    const numericValue = value.replace(/,/g, '');
    if (!numericValue) return '';
    return Number(numericValue).toLocaleString('en-US');
  };

  const handleBudgetChange = (e) => {
    const input = e.target.value.replace(/,/g, '');
    // Allow only digits
    if (/^\d*$/.test(input)) {
      setBudget(formatNumber(input));
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    const split = value
      .split(",")
      .map((k) => k.trim())
      .filter((k) => k.length > 0);
    setKeywords(split);
  };
// In SearchFilter component
const handleSubmit = async () => {
    setPage(1);  // Reset page to 1 before applying filters
    setIsLoading(true);
    setGetProperty([]);  // Reset previous properties

    // Apply filters
    const filters = {
        type: type === "Other" ? typeOther.trim() : type,
        budget,
        handover,
        location: locationSelect?.value || "",
        developer: developer === "Other" ? developerOther.trim() : developer,
        project: project?.label || "",
        keywords: keywords.join(", "),
    };

    setActiveFilters(filters);
    setActiveFilter(true);
    setIsLoading(false);

    // Delay scroll by 100ms to ensure the DOM is ready
    setTimeout(() => {
        const propertiesSection = document.getElementById("properties-section");
        if (propertiesSection) {
            propertiesSection.scrollIntoView({ behavior: "smooth" });
        }
    }, 100);
};

// Ensure the page is properly set here
useEffect(() => {
    setIsLoading(true);
    getPropertyData(page, sortBy, selectedCategory).finally(() => setIsLoading(false));
}, [page, sortBy, selectedCategory]);

  return (
   <section className="py-16 bg-gray-50">
<div className="text-center max-w-3xl mx-auto mb-12 px-5 md:px-0">
  <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4 leading-tight">
    {t('searchFilter.title')}
  </h2>
  <p className="text-gray-600 text-base md:text-lg leading-relaxed">
    {t('searchFilter.description')}
  </p>
</div>

<div dir={isArabic ? 'rtl' : 'ltr'}>
  {/* All input fields inside here will inherit RTL or LTR */}


    <div className="bg-white rounded-2xl shadow-lg p-8 max-w-7xl mx-auto">
      {/* <h2 className="text-xl font-semibold mb-6">
        Your Next Home, Found by AI
      </h2> */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
       <Autocomplete
  options={typeOptions}  // Options like "Apartment", "Villa", etc.
  value={type}  // The currently selected unit type
  onChange={(_, val) => setType(val)}  // Update the type state when user selects a unit type
  size="small"
  renderInput={(params) => (
    <TextField {...params} label={t('searchFilter.whatLookingFor')} />
  )}
/>

        {type === "Other" && (
          <TextField
            size="small"
            fullWidth
            value={typeOther}
            onChange={(e) => setTypeOther(e.target.value)}
            placeholder="Other: ____"
            margin="normal"
            
          />
        )}

        {/* <Autocomplete
          options={budgetOptions}
          value={budget}
          onChange={(_, val) => setBudget(val)}
          renderInput={(params) => (
            <TextField {...params} label="What’s your budget?" />
          )}
        /> */}

<TextField
  size="small"
  fullWidth
  label={t('searchFilter.budget')}
  value={budget}
  onChange={handleBudgetChange}
  inputProps={{ inputMode: 'numeric', dir: isArabic ? 'rtl' : 'ltr' }}
  InputLabelProps={{ style: { direction: isArabic ? 'rtl' : 'ltr' } }}
/>


        <Autocomplete
          size="small"
          options={handoverYears}
          value={handover}
          onChange={(_, val) => setHandover(val)}
          renderInput={(params) => (
            <TextField {...params} label={t('searchFilter.handover')} />
          )}
        />
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6">
        <Autocomplete
          size="small"
          options={emirateOptions}
          getOptionLabel={(option) => option.label}
          value={locationSelect}
          onChange={(_, newValue) => setLocationSelect(newValue)}
          isOptionEqualToValue={(option, value) => option.label === value?.label}
          renderInput={(params) => (
            <TextField {...params}  label={t('searchFilter.city')} fullWidth />
          )}
        />

        <Autocomplete
          size="small"
          options={developerOptions}
          value={developer}
          onChange={(_, val) => setDeveloper(val)}
          renderInput={(params) => (
            <TextField {...params} label={t('searchFilter.developer')} />
          )}
        />
        {/* {developer === "Other" && (
          <TextField
            fullWidth
            value={developerOther}
            onChange={(e) => setDeveloperOther(e.target.value)}
            placeholder="Other: ____"
            margin="normal"
          />
        )} */}

        {/* <TextField
          fullWidth
          label="Project Name"
          value={project}
          onChange={(e) => setProject(e.target.value)}
        /> */}

        <Autocomplete
          size="small"
          options={projectOptions}
          value={project}
          onChange={(_, newValue) => setProject(newValue)}
          getOptionLabel={(option) => option?.label || ""}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          renderInput={(params) => (
            <TextField {...params} label={t('searchFilter.project')} />
          )}
        />



      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6 items-end">
        <TextField
        
          size="small"
          label={t('searchFilter.keywords')}
          multiline
          minRows={1}
          fullWidth
          value={inputValue}
          onChange={handleChange}
          placeholder={t('searchFilter.keywordsPlaceholder')}
        />
        <div>
          <SearchFilterModal 
            developerOptions={developerOptions}
            developer={developer}
            setDeveloper={setDeveloper}

            projectOptions={projectOptions}
            project={project}
            setProject={setProject}

            communityOptions={communityOptions}

            roomOptions={roomOptions}
            unitTypeOptions={unitTypeOptions}
            salesStatusOptions={salesStatusOptions}
            projectStatusOptions={projectStatusOptions}
            projectTypeOptions={projectTypeOptions}
            amenityOptions={amenityOptions}
            // handleSearch={handleSearch}
            setPage={setPage}
            // setPropertyData={setPropertyData}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            handleSubmit={handleSubmit}
            setProjectStatus={setProjectStatus}
            projectStatus={projectStatus}
            setSalesStatus={setSalesStatus}
            salesStatus={salesStatus}
            setProjectType={setProjectType}
            projectType={projectType}
            setUnitType={setUnitType}
            unitType={unitType}
            setRooms={setRooms}
            rooms={rooms}
            setFacility={setFacility}
            facility={facility}
            setCommunity={setCommunity}
            community={community}
            setRentalGuarantee={setRentalGuarantee}
            rentalGuarantee={rentalGuarantee}
            setPaymentPlan={setPaymentPlan}
            paymentPlan={paymentPlan}
            setDeliveryPlan={setDeliveryPlan}
            deliveryPlan={deliveryPlan}
            setMinPrice={setMinPrice}
            minPrice={minPrice}
            setMaxPrice={setMaxPrice}
            maxPrice={maxPrice}
            setMinArea={setMinArea}
            minArea={minArea}
            setMaxArea={setMaxArea}
            maxArea={maxArea}
            setDownPayment={setDownPayment}
            downPayment={downPayment}
            setDeliveryDate={setDeliveryDate}
            deliveryDate={deliveryDate}
            handleRest={handleRest}

            setNewUnitType={setNewUnitType}
            newUnitType={newUnitType}

            // searchTrigger={searchTrigger}
            // setSearchTrigger={setSearchTrigger}
            // community={community}
            // setCommunity={setCommunity}
          />
        </div>
        <div className="flex justify-end">
          <button
            onClick={handleSubmit}
            disabled={isLoading} // 🛑 Prevent repeated clicks
            className={`bg-teal-500 hover:bg-teal-600 text-white rounded-full px-6 py-3 flex items-center justify-center gap-2 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <FiFilter className="text-lg" />
           {isLoading ? t('searchFilter.searching') : t('searchFilter.findProperties')}

          </button>

        </div>
      </div>
    </div>
    </div>
    </section>
  );
}
